import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/tree-select/tree-select.component';
import type { NomenclatureGroupFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-group-find.dto';

@Component({
  selector: 'crm-nomenclature-group-single-select',
  standalone: true,
  imports: [CommonModule, TreeSelectComponent],
  templateUrl: './nomenclature-group-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NomenclatureGroupSingleSelectComponent {
  @Input() public loading: boolean;
  @Input() public disabled: boolean;
  @Input() public groupsDisabled = false;
  @Input() public showClear = false;
  @Input() public scrollHeight = '300px';
  @Input() public class: string;
  @Input() public label: string;
  @Input() public styleClass: any;
  @Input() public appendTo: string;
  @Input() public panelStyleClass: string;

  @Output() public panelShow = new EventEmitter<any>();
  @Output() public panelHide = new EventEmitter<any>();

  @Output() public selectedNomenclatureChange = new EventEmitter<NomenclatureGroupFindInterface>();

  @Input() public customRequest = false;
  @Input() public sort: string;

  public _nomenclatures: NomenclatureGroupFindInterface[] = [];
  public _selectedNomenclature: NomenclatureGroupFindInterface;

  @Input()
  public set selectedNomenclature(nomenclature: NomenclatureGroupFindInterface) {
    this._selectedNomenclature = nomenclature;
  }

  @Input()
  public set nomenclatures(nomenclatures: NomenclatureGroupFindInterface[]) {
    this._nomenclatures = nomenclatures;
  }

  public selectNomenclaturesHandler(nomenclature: NomenclatureGroupFindInterface) {
    this.selectedNomenclatureChange.emit(nomenclature);
  }
}
